import React, { FC, useCallback } from 'react';
import { observer } from 'mobx-react';
import { WidgetBase } from 'src/libs/ui-kit/widget-base/WidgetBase';
import { useStore } from 'src/modules/users/hooks/useStore';
import { UserOrdersStoreContext } from '../../UserOrders.widget';
import { OrderRow } from '../tables/OrderRow';
import { IUserOrdersWidgetProps } from '../../interfaces';
import { WidgetTable } from 'src/libs/ui-kit/widget-table/WidgetTable';
import { ListContainer } from 'src/components/Containers/ListContainer/ListContainer';
import { EHandlerListType } from '../../../../../../interfaces';
import { PaginationField, TPagination } from '@qlean/admin-web-list-view';
import styles from './styles.module.scss';

export const ContractorOrdersWidget: FC<IUserOrdersWidgetProps> = observer(({ col, title }) => {
  const store = useStore(UserOrdersStoreContext);
  const { areOrdersLoading, getOrdersInformation, hasError, limit, page, total, updateLoadParams } = store;
  const pagination: TPagination = { limit, page, total };

  const handlePagination = useCallback((pagination: TPagination) => {
    updateLoadParams({ type: EHandlerListType.pagination, value: { pagination } });
  }, []);

  return (
    <WidgetBase col={col} title={title} isLoading={areOrdersLoading} isEmpty={total === 0} hasError={hasError}>
      <div className="px-5">
        <WidgetTable>
          <thead>
            <tr>
              <th className="border-0 text-tiny pt-0">Корзина</th>
              <th className="border-0 text-tiny pt-0">Адрес</th>
              <th className="border-0 text-tiny pt-0">Заказ</th>
              <th className="border-0 text-tiny pt-0">Исполнитель</th>
              <th className="border-0 text-tiny pt-0">Стоимость</th>
            </tr>
          </thead>
          <tbody>
            <ListContainer ItemComponent={OrderRow} items={getOrdersInformation} />
          </tbody>
        </WidgetTable>
        <PaginationField
          limitList={[5, 10, 50]}
          className={styles.paginationField}
          handlePagination={handlePagination}
          pagination={pagination}
        />
      </div>
    </WidgetBase>
  );
});
